export const CREATE_ADMIN_POLICIES_PROCEDURES = "CREATE_ADMIN_POLICIES_PROCEDURES";   
export const RETRIEVE_ADMIN_POLICIES_PROCEDURES = "RETRIEVE_ADMIN_POLICIES_PROCEDURES";
export const RETRIEVESINGLE_ADMIN_POLICIES_PROCEDURES = "RETRIEVESINGLE_ADMIN_POLICIES_PROCEDURES";
export const UPDATE_ADMIN_POLICIES_PROCEDURES = "UPDATE_ADMIN_POLICIES_PROCEDURES";   
export const DELETE_ADMIN_POLICIES_PROCEDURES = "DELETE_ADMIN_POLICIES_PROCEDURES";   
